export default __webpack_public_path__ + "docx_16x1.png";